import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
import { getLuminance, setLightness } from 'polished';
var Menu = styled(AntMenu)(_templateObject || (_templateObject = _taggedTemplateLiteral(["&& {\n  border-color: ", ";\n\n  &.ant-menu.ant-menu-horizontal {\n    background-color: transparent;\n\n    & > li.ant-menu-item {\n      height: auto;\n      margin: 0 1rem;\n\n      &:nth-child(2) {\n        margin-left: 0;\n      }\n      &:nth-last-child(2) {\n        margin-right: 0;\n      }\n    }\n\n  }\n\n  &.ant-menu.ant-menu-vertical {\n    & > li.ant-menu-item:hover {\n      background-color: ", ";\n    }\n  }\n\n  li.ant-menu-item {\n    height: auto;\n  }\n\n  li.ant-menu-item-selected {\n    font-weight: bold;\n  }\n  li.ant-menu-item-selected, li.ant-menu-item:hover {\n    color: ", ";\n    border-bottom-color: ", ";\n\n    a {\n      color: ", ";\n    }\n  }\n}"])), function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return setLightness(0.925, props.theme.colors.grey);
}, function (props) {
  return props.theme.colors[props['data-colorscheme']];
}, function (props) {
  return props.theme.colors[props['data-colorscheme']];
}, function (props) {
  return props.theme.colors[props['data-colorscheme']];
});
Menu.defaultProps = {
  'data-colorscheme': 'primary'
};
var MenuItem = styled(AntMenu.Item).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['colorScheme'].includes(prop);
  }
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &.ant-dropdown-menu-item {\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.colorScheme && props.theme.colors[props.colorScheme];
}, function (props) {
  return props.colorScheme ? props.theme.colors[props.colorScheme] : setLightness(0.925, props.theme.colors.grey);
}, function (props) {
  return props.colorScheme && getLuminance(props.theme.colors[props.colorScheme]) < 0.5 ? props.theme.colors.light : props.theme.colors.dark;
}); // @ts-ignore
// typeof menu item needs to have a context type

Menu.Item = MenuItem;
export default Menu;